<template>
  <div class="cell" v-if="calculateData.display" :data-hour="cellData.hour" :data-minute="cellData.minute" >
    <div v-if="!calculateData.outOfDate" class="brick" :class="classBrickObject" @click="clickHandler">
      <template v-if="calculateData.isBooking && !calculateData.isMyBooking">
        <div class="viewprice" :class="{show: calculateData.viewPrice}">
          <div class="price">занято</div>
        </div>
      </template>

      <template v-if="!calculateData.isBooking || calculateData.isMyBooking">
        <div class="viewprice" :class="{show: calculateData.viewPrice}">
          <div class="price" v-show="!calculateData.isBooking">{{ cellData.price }} ₽</div>
          <div class="cancel">
            <span class="icon"></span>{{ cellData.cancelTime }} ч.
          </div>
          <div class="lbl" v-show="calculateData.isMyBooking">Моя бронь</div>
        </div>
        <div class="percernt-wrap" v-if="this.getMySelect && calculateData.cancelRetention">
          <i class="percent">-{{ percentRetention }}%</i>
        </div>
      </template>
    </div>
    <div v-else>
      <span class="outdate" v-if="!calculateData.isMyBooking">время<br> истекло</span>
      <span class="outdate my" v-if="calculateData.isMyBooking">
        <div class="lbl">Моя бронь</div>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BTCell',
  inject: ['officeId', 'selectData', 'mySelectData', 'errorData', 'percentRetention', 'memoryData'],
  props: {
    cellData: Object,
    calculateDt: Object,
    // errorDt: Object,
    index: Number
  },
  mounted() {
    let key = this.officeId + ':' + this.cellData.cabinetId + ':' + this.cellData.hour + ':' + this.cellData.minute;
    this.$emitter.off('autoselect_pill_' + key)
    this.$emitter.on('autoselect_pill_' + key, () => {
      this.clickHandler()
    })
  },
  created() {
    // this.memoryData = this.$cookies.get('selectorDataBeforeAddBalance')
    // проверка, есть ли запомненные данные по выбранным ячейкам (выбранные перед оплатой баланса)
    // console.log('this.memoryData 2: ', this.memoryData)
    // if (this.$store.state.memoryData && this.$store.state.memoryData != null && this.$store.state.memoryData != 'false') {
    //   let key = this.officeId + ':' + this.cellData.cabinetId + ':' + this.cellData.hour + ':' + this.cellData.minute;
    //   if (this.$store.state.memoryData['officeSelectData'].indexOf(key) != -1) {
    //     this.clickHandler(false)
    //   }
    // }
  },
  computed: {
    classBrickObject() {
      let cd = this.calculateData
      return {
        'start': cd.isFirst,
        'darken': cd.isEndWorkDay,
        'end': cd.isLast,
        'mybooking': cd.isMyBooking,
        'busy': !cd.isMyBooking && cd.isBooking,
        'selbooking': !cd.isMyBooking && this.getSelect,
        'selmybooking': cd.isMyBooking && this.getMySelect,
        'error': this.getError
      }
    },
    calculateData() {
      return this.calculateDt[this.index]
    },
    getError() {
      let d = this.cellData;
      let type = this.calculateData.isMyBooking ? 'my' : 'new'
      return this.isSet(this.errorData[type][this.officeId + ':' + d.cabinetId + ':' + d.hour + ':' + d.minute])
    },
    getSelect() {
      let d = this.cellData;
      return this.isSet(this.selectData[this.officeId + ':' + d.cabinetId + ':' + d.hour + ':' + d.minute])
    },
    getMySelect() {
      let d = this.cellData;
      return this.isSet(this.mySelectData[this.officeId + ':' + d.cabinetId + ':' + d.hour + ':' + d.minute])
    }
  },
  methods: {
    isSet(val) {
      return typeof val !== 'undefined'
    },
    clickHandler: function (validate = true) {
      if (!this.calculateData.isMyBooking && this.calculateData.isBooking) {
        return
      }

      let type = this.calculateData.isMyBooking ? 'my' : 'new'
          , setData = Object.assign({
        officeId: this.officeId,
        cancelRetention: this.calculateData.cancelRetention,
        bookingParam: this.calculateData.bookingParam
      }, this.cellData, {
        select: type === 'new' ? !this.getSelect : !this.getMySelect,
        index: this.index,
        mode: type,
      })
      this.$store.dispatch('selector/setSelect', setData)
      // console.log(this.$store.state.selector);
      // console.log(this.$store.state.booking.data);
      if (validate) this.$emit("validate");
    }
  }
}
</script>
<style scoped>

.percernt-wrap {
  position: absolute;
  bottom: -.5em;
  left: 0;
  right: 0;
}

.percent {
  font-weight: bold;
  color: #ff8a17;
  background: #fff;
  font-size: .7em;
  border-radius: 3px;
  line-height: .91rem;
  padding: 1px 2px;
}

.cell {
  position: relative;
  display: flex;
  width: 4rem;
  height: 4rem;
  /*border-left: 1px solid #f5f5f5;*/
  align-items: center;
  justify-content: center;
  font-size: .9rem;
  /*background: #81B29A;*/
}
.vertical .cell {
  width: 100%;
  margin-top: 1px;
  margin-bottom: 1px;
}
.brick2 {
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background: #81B29A;
  color: #fff;
  /*width: 4rem;*/
  /*height: 3.6rem;*/
  width: calc(100% - 1px);
  height: 90%;
  /*top:2px;*/
  /*left: 0px;*/
  z-index: 10;
  //transition: all ease .4s;
  /*border-right: 1px solid #628A76;*/
  user-select: none;
}

.outdate,
.brick {

  position: absolute;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background: #81B29A;
  color: #fff;
  width: 4rem;
  height: 3.6rem;

  margin-bottom: 1px;
  top: 2px;
  left: 0px;
  z-index: 10;
  //transition: all ease .4s;
  border-right: 1px solid #628A76;
  user-select: none;
  text-align: center;
}

.outdate {
  /*display: block;*/
  font-size: .7rem;
  background: #e2e2e2;
  text-align: center;
  border-right: 1px solid #fff;
  border-radius: 5px;
  color: #b3b3b3;
}

.vertical .brick,
.vertical .outdate {
  width: 100%!important;
  top: 0px;
  height:100%;
  border-right: none;

}

.outdate.my {
  font-size: .5rem;
  background: #beab5e66;
  /*color:#ada291;*/
}

.outdate.my .lbl {
  font-size: .6rem;
  color: #a38049;
}

.brick.darken {

  background: #628A76;
  border-right-color: #506E5F;

}

.brick.darken:hover {
  background: #527A66;
}

.brick:hover {
  background: #61927A;
  cursor: pointer;
}

.brick.mybooking {
  background: #F2CC8F;
  border-color: #CFB180;
}


.selmybooking > .lbl {
  text-decoration: line-through;

}

.brick.selmybooking:before,
.brick.selbooking:before {
  content: '';
  position: absolute;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%2336ad21'  viewBox='0 0 16 16'%3E%3Cpath d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z'/%3E%3C/svg%3E%0A");
  /*background: #fff;*/
  /*background: #36ad21;*/
  top: -3px;
  right: 3px;

  display: block;
  width: 1.05rem;
  height: 1.05rem;
  background-repeat: no-repeat;
  background-size: 90%;
  background-position: center;
  z-index: 1000;
  border-radius: 50%;
}

.lbl {
  font-size: .55rem;
  text-align: center;
  line-height: .7rem;
  margin-top: 2px;
}


.brick.error:after {
  content: '';
  position: absolute;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%23ff8a17' viewBox='0 0 16 16'%3E%3Cpath d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z'/%3E%3C/svg%3E");
  top: -3px;
  left: 3px;
  display: block;
  width: 1.05rem;
  height: 1.05rem;
  background-repeat: no-repeat;
  background-size: 90%;
  background-position: center;
  z-index: 1000;
  border-radius: 50%;
}

.brick.busy {
  background: #f2f0ed;
  border-color: #e0dfdd;
  cursor: not-allowed;
  color: #b9b9b9;
}

.brick.darken.selbooking,
.brick.selbooking {
  background: #59c57d;
  border-color: #459a61;
}

.brick.mybooking:hover {
  background: #E2BC7F;
}

.brick.darken.selmybooking,
.brick.selmybooking {

  /*background: #81b29a;*/
  /*border-color: #628A76;*/
  background: #b16060;
  border-color: #854242;
}

.brick.mybooking.selmybooking:hover {
  /*background: #527A66;*/
  background: #974646;
}

.brick.mybooking .user-circle {
  display: flex;
  width: 2.2rem;
  height: 2.2rem;
  background: #F4F1DE;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  color: #BE8A5E;
}

.brick.start {
  border-radius: 5px 0 0 5px;
  left: 4px;
  width: calc(4rem - 4px);
}
.vertical .brick.start{
  border-radius: 5px 5px  0 0 ;
  left: 0px;
  margin-top: 1px;
  height: calc(100% - 1px);
  //width: 100%;
}
.brick.end {
  border-right: none;
  border-radius: 0 5px 5px 0;
  right: 4px;
  width: calc(4rem - 4px);
}
.vertical .brick.end{
  border-radius: 0 0  5px  5px;
  right: 0px;
  margin-bottom: 1px;
  height: calc(100% - 1px);
}

.brick.start.end {
  border-right: none;
  border-radius: 5px;
  width: calc(4rem - 8px);
}

.brick .price {
  font-size: .75rem;
  text-align: center;
}

.brick .cancel {
  font-size: .69rem;
  text-align: center;
}

.icon {
  position: relative;
  display: inline-block;
  width: 1rem;
  height: 1rem;
  background-repeat: no-repeat;
  background-position: bottom;
  margin-right: 0.3rem;
}

.brick .cancel .icon {
  position: relative;
  display: inline-block;
  top: 2px;
  background-repeat: no-repeat;
  background-position: center;
  width: 12px;
  height: 13px;
  background-image: url("data:image/svg+xml, %3Csvg width='12' height='13' viewBox='0 0 10 11' fill='%23FFFFFF' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.59175 1.3999C3.36925 1.3999 1.56125 3.1809 1.50725 5.3979V5.5004H0.321251L2.11825 7.4474L3.86525 5.5004H2.52925V5.3979C2.58275 3.7464 3.93325 2.4254 5.59175 2.4254C7.28475 2.4254 8.65725 3.8024 8.65725 5.5004C8.65725 7.1984 7.28475 8.5754 5.59175 8.5754C4.93899 8.57579 4.30333 8.36671 3.77825 7.9789L3.07525 8.7309C3.79276 9.29484 4.67915 9.60093 5.59175 9.5999C7.84925 9.5999 9.67875 7.7649 9.67875 5.5004C9.67875 3.2359 7.84925 1.3999 5.59175 1.3999ZM5.09175 3.0004V5.5004C5.09232 5.63289 5.14494 5.75985 5.23825 5.8539L6.83825 7.4539C6.97975 7.3624 7.11325 7.2594 7.23175 7.1399L6.09175 6.0004V3.0004H5.09175Z' fill='%23FFFFFF'/%3E%3C/svg%3E");
}
</style>